<section class="bemerkung-editor" aria-label="Bemerkung bearbeiten" [attr.aria-busy]="laden || speichern || bilderPruefen">
  <label class="bemerkung-betreff">Betreff <span aria-hidden="true">*</span>
    <input class="form-control" [(ngModel)]="betreff" [disabled]="speichern" required autofocus>
  </label>
  <p class="bemerkung-feldname">Bemerkung (Vermerk)</p>
  <input #dateiauswahl type="file" accept="image/png,image/jpeg" multiple hidden (change)="dateienAusgewaehlt($event)">
  <dx-html-editor #editor [(value)]="html" [height]="420" [toolbar]="toolbar" [mediaResizing]="{ enabled: true }"
    [readOnly]="laden || speichern || bilderPruefen || ladefehler" [customizeModules]="moduleAnpassen"
    (onInitialized)="initialisieren($event)" (onContentReady)="bereit()">
  </dx-html-editor>
  <p class="bemerkung-hilfe">PNG/JPEG: höchstens 10 Bilder, 5 MiB je Bild und 20 MiB insgesamt. Screenshots können Sie mit Strg+V einfügen.</p>
  <p *ngIf="laden" role="status">{{ bilderWerdenGeladen ? 'Bilder werden geladen …' : 'Bemerkungsfeld wird vorbereitet …' }}</p>
  <p *ngIf="bilderPruefen" role="status">Bilder werden geprüft …</p>
  <p *ngIf="neueBilder" role="status">{{ neueBilder }} neue Bilder werden mit der Bemerkung gespeichert.</p>
  <p *ngIf="hinweis" role="status">{{ hinweis }}</p>
  <div *ngIf="fehler" class="alert alert-danger" role="alert">
    {{ fehler }}
    <button *ngIf="ladefehler" type="button" class="btn btn-default" (click)="bilderLaden()">Bilder erneut laden</button>
    <button *ngIf="konflikt" type="button" class="btn btn-default" (click)="neuLaden()">Aktuellen Stand laden</button>
  </div>
  <div class="bemerkung-aktionen">
    <button type="button" class="btn btn-success" [disabled]="laden || speichern || bilderPruefen || ladefehler" (click)="speichernKlick()">{{ speichern ? 'Wird gespeichert …' : 'Speichern' }}</button>
    <button type="button" class="btn btn-default" [disabled]="speichern" (click)="abgebrochen.emit()">Abbrechen</button>
  </div>
</section>
